/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { PawnShopMock, PawnShopMockInterface } from "../PawnShopMock";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "positionId",
        type: "uint256",
      },
    ],
    name: "getPosition",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "borrower",
            type: "address",
          },
          {
            internalType: "address",
            name: "depositToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "depositAmount",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "open",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "minAuctionAmount",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "posDurationBlocks",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "posFee",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "createdBlock",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "createdTs",
                type: "uint256",
              },
            ],
            internalType: "struct IPawnShop.PositionInfo",
            name: "info",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "collateralToken",
                type: "address",
              },
              {
                internalType: "enum IPawnShop.AssetType",
                name: "collateralType",
                type: "uint8",
              },
              {
                internalType: "uint256",
                name: "collateralAmount",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "collateralTokenId",
                type: "uint256",
              },
            ],
            internalType: "struct IPawnShop.PositionCollateral",
            name: "collateral",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "acquiredToken",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "acquiredAmount",
                type: "uint256",
              },
            ],
            internalType: "struct IPawnShop.PositionAcquired",
            name: "acquired",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "lender",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "posStartBlock",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "posStartTs",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "posEndTs",
                type: "uint256",
              },
            ],
            internalType: "struct IPawnShop.PositionExecution",
            name: "execution",
            type: "tuple",
          },
        ],
        internalType: "struct IPawnShop.Position",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "positionId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "borrower",
            type: "address",
          },
          {
            internalType: "address",
            name: "depositToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "depositAmount",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "open",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "minAuctionAmount",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "posDurationBlocks",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "posFee",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "createdBlock",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "createdTs",
                type: "uint256",
              },
            ],
            internalType: "struct IPawnShop.PositionInfo",
            name: "info",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "collateralToken",
                type: "address",
              },
              {
                internalType: "enum IPawnShop.AssetType",
                name: "collateralType",
                type: "uint8",
              },
              {
                internalType: "uint256",
                name: "collateralAmount",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "collateralTokenId",
                type: "uint256",
              },
            ],
            internalType: "struct IPawnShop.PositionCollateral",
            name: "collateral",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "acquiredToken",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "acquiredAmount",
                type: "uint256",
              },
            ],
            internalType: "struct IPawnShop.PositionAcquired",
            name: "acquired",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "lender",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "posStartBlock",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "posStartTs",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "posEndTs",
                type: "uint256",
              },
            ],
            internalType: "struct IPawnShop.PositionExecution",
            name: "execution",
            type: "tuple",
          },
        ],
        internalType: "struct IPawnShop.Position",
        name: "data",
        type: "tuple",
      },
    ],
    name: "setPosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class PawnShopMock__factory {
  static readonly abi = _abi;
  static createInterface(): PawnShopMockInterface {
    return new Interface(_abi) as PawnShopMockInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): PawnShopMock {
    return new Contract(address, _abi, runner) as unknown as PawnShopMock;
  }
}
